import { useI18n } from '../i18n';
import styles from './Problems.module.css';

export function Problems() {
  const { t } = useI18n();

  return (
    <section className={styles.section}>
      {t.problems.items.map((item) => (
        <div key={item.title}>
          <h2 className={styles.title}>{item.title}</h2>
          <p className={styles.body}>{item.body}</p>
        </div>
      ))}
    </section>
  );
}
